module.exports = [
  require('./bael'),
  require('./balhannoth'),
  require('./baphomet'),
  require('./berbalang'),
  require('./bronze_scout'),
  require('./boneclaw'),
  require('./bulezau'),
]
